export const context = {
    'users': "pas d'utilisateur | {count} utilisateur | {count} utilisateurs",
    'no-account': {
        title: "Aucun compte",
        text: "attaché à ce cabinet"
    },
    'update-title': "Modifier les accès et paramètres pour ce compte",
    'rfe-badge': {
        label: "activer le pack RFE",
        title: "Ce remplaçant n'a pas de pack RFE. Cliquez pour lui en activer un."
    }
}
